export const ActivityFeedGroup = ({ children, groupTitle }) => {
  return (
    <div className="activity-feed-group">
      {groupTitle && (
        <>
          <h3 className="activity-feed-group__title">{groupTitle}</h3>
          <div className="activity-feed-group__separator"></div>
        </>
      )}
      <div className="activity-feed-group__activities-list">{children}</div>
    </div>
  );
};
